import { createBrowserRouter, RouterProvider } from "react-router";

import { ROUTER_ROUTES } from "./router.constant";

export const Router = () => {
  return <RouterProvider router={createBrowserRouter(ROUTER_ROUTES)} />;
};
